import { handleError, handleSuccess, triggerBizApi, triggerPost } from './utils';
const signUpApiRequest = async (email, password, newsletter, marketing) => {
  const agreementsDecision = 'agreements_decision[]';
  const agreementsType = 'agreements_type[]';
  const apiPayload = {
    users_email: email,
    users_password: password,
    [agreementsType]: ['email', 'marketing'],
    [agreementsDecision]: [newsletter ? 'Y' : 'N', marketing ? 'Y' : 'N']
  };
  const apiResponse = await triggerPost('/public/users/', apiPayload, false);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 201) {
    return handleSuccess(responseData, false, {
      email
    });
  }
  return handleError(responseData);
};
const registerBizApiRequest = async (fullName, email, password) => {
  const query = "mutation {\n          register(fullName: \"".concat(fullName, "\", email: \"").concat(email, "\", password: \"").concat(password, "\") \n        }");
  const apiResponse = await triggerBizApi(query);
  const responseData = await apiResponse.json();
  return responseData;
};
const confirmRegistBizApiRequest = async code => {
  const query = "mutation {\n          confirm(code: \"".concat(code, "\") \n        }");
  const apiResponse = await triggerBizApi(query);
  const responseData = await apiResponse.json();
  return responseData;
};
export { signUpApiRequest, registerBizApiRequest, confirmRegistBizApiRequest };